import { NewsStatusEnum } from 'APIPackage/NewsModule/enums/NewsStatusEnum';

import { INewsForm } from '../interfaces/INewsForm';

export const initialNewsForm: INewsForm = {
  type: undefined,
  status: NewsStatusEnum.CREATED,
  title: '',
  shortText: '',
  text: '',
  created: '',
  published: '',
  expired: '',
  attachments: undefined,
  roles: undefined,
  stripHtmlTags: undefined,
};
